import { useState, useCallback, useEffect } from 'react';
import usePasswordChange from '../../../hooks/api/usePasswordChange';
import useForm from '../../../hooks/useForm';
import { RECOVER_PASSWORD_STEPS } from '../../../utils/enums';
import { catalogs } from '../../../utils/catalogs';
import { PATH_AUTH } from '../../../routes/paths';
import { useNavigate } from 'react-router';

const useRecoverPasswordView = () => {



    // system
    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)
    const [method, setMethod] = useState(1)
    const navigate = useNavigate()


    const passwordChangeManager = usePasswordChange()
    const {form, onChangeForm, setForm, onGetFormData, onResetForm} = useForm(form_data)

    //console.log(form)
    // data
    const [code, setCode] = useState('')

    const [view, setView] = useState(RECOVER_PASSWORD_STEPS.SELECT_METHOD)

    useEffect(() => {
        onResetForm()
        setLoading(false)
        setSending(false)
        setError(null)
        setMethod(1)
        setView(RECOVER_PASSWORD_STEPS.SELECT_METHOD)
    }, [])


    const onSelectedMethod = useCallback((value) => {
        console.log('Metodo seleccionado', value)
        setMethod(value)
        setView(value === 'mobile' || value === 'whatsapp'
        ? RECOVER_PASSWORD_STEPS.CELLPHONE 
        : RECOVER_PASSWORD_STEPS.EMAIL
        )
    }, [])

    const onRequestVerificationCode = useCallback(async() => {
        if(method === 'email') onRequestVerificationEmailCode()
        if(method === 'mobile' || method === 'whatsapp') onRequestVerificationMobileCode()
    }, [method, form])

    const onRequestVerificationEmailCode = useCallback(async() => {
        if(sending) return
        try{    
            setSending(true)
            const data2send = {
                email:form.email.value
            }
            console.log(data2send)
            //await registrationManager.actions.onCheckEmail(data2send)
            await passwordChangeManager.actions.onSendEmailPin(data2send)
            setSending(false)
            setError(null)
            if(view !== RECOVER_PASSWORD_STEPS.VERIFICATION_CODE) setView(RECOVER_PASSWORD_STEPS.VERIFICATION_CODE)
        }catch(error){
            console.log(error)
            setSending(false)
            setError(error)
        } 

    }, [view, form, sending])

    const onRequestVerificationMobileCode = async() => {
        if(sending) return

        console.log(form)

        try{    
            setSending(true)
            const data2send = {
                mobile: form.mobile.value,
                mobile_country_id: form.mobile_country_id.value, 
                type: method === 'mobile' ? 'sms' :'whatsapp'
            }
            console.log(data2send)
            await passwordChangeManager.actions.onSendMobilePin(data2send)
            setSending(false)
            setError(null)
            if(view !== RECOVER_PASSWORD_STEPS.VERIFICATION_CODE) setView(RECOVER_PASSWORD_STEPS.VERIFICATION_CODE)
        }catch(error){
            console.log(error)
            setSending(false)
            setError(error)
        } 

    }

    const onConfirmCode = useCallback(async()=> {

        try{
            setSending(true)
            if(method === 'mobile' || method === 'whatsapp'){
                const data2send = {
                    code: code,
                    mobile: form.mobile.value,
                    mobile_country_id: form.mobile_country_id.value,
                }
                await passwordChangeManager.actions.onValidateMobilePin(data2send)
            }else{
                const data2send = {
                    code: code,
                    email: form.email.value,
                }
                await passwordChangeManager.actions.onValidateEmailPin(data2send)
            }
            setSending(false)
            //setIsValid(false)
            setView(RECOVER_PASSWORD_STEPS.PASSWORD)
        }catch(error){
            console.log(error)
            setSending(false)
            setError(error)
        }
    }, [code, form, method])

    const onGoToLogin = useCallback(() =>{
        navigate(PATH_AUTH.login)
    }, [])

    const onUpdatePhoneCode = useCallback((_data) => {
        setCode(_data)
        setError(null)
    }, [])

    const onReset = useCallback(() => {
        onResetForm()
        setLoading(false)
        setSending(false)
        setError(null)
        setCode('')
        setView(RECOVER_PASSWORD_STEPS.SELECT_METHOD)
    }, [])

    const onChangeRegistrationMethod = useCallback(() => onReset(),[])

    const onCloseError = useCallback(() => setError(null), [])

    const onGoBack = useCallback(() => {
        setError(null)

        const ismobile = method === 'mobile' || method === 'whatsapp'

        if(view === RECOVER_PASSWORD_STEPS.SELECT_METHOD){

        }
        if(view === RECOVER_PASSWORD_STEPS.CELLPHONE || view === RECOVER_PASSWORD_STEPS.EMAIL){
            setView(RECOVER_PASSWORD_STEPS.SELECT_METHOD)
            return
        }
        if(view === RECOVER_PASSWORD_STEPS.VERIFICATION_CODE){
            setView( ismobile ?  RECOVER_PASSWORD_STEPS.CELLPHONE : RECOVER_PASSWORD_STEPS.EMAIL)
            return
        }
        if(view === RECOVER_PASSWORD_STEPS.PASSWORD){
            setView( ismobile ?  RECOVER_PASSWORD_STEPS.CELLPHONE : RECOVER_PASSWORD_STEPS.EMAIL)
            return
        }
    }, [view, method])

    const onSubmit = useCallback(async() => {

        setSending(true)
        let token
        let data2send = onGetFormData({removeEmptySpaces:true})
        delete data2send.passwordConfirmation
        data2send.code = code


        try {
            if(method === 'mobile' || method === 'whatsapp'){
                delete data2send.email 
                token = await passwordChangeManager.actions.onExecuteWithPin(data2send)
            }else{
                delete data2send.mobile 
                delete data2send.mobile_country_id 
                token = await passwordChangeManager.actions.onExecuteEmailPin(data2send)
            }
        } catch (error) {
            
            console.log(error)
            setSending(false)
            setError(error)
            return
        }
        
        
        
        setView(RECOVER_PASSWORD_STEPS.SUCCESS)
        setSending(false)
        
    }, [form, method, code])

    const system = {loading, error, sending}

    return {system,
        view, code, form,
        method,
        onSelectedMethod,
        onRequestVerificationEmailCode,
        onRequestVerificationMobileCode,
        onRequestVerificationCode,
        onConfirmCode,
        onChangeForm,
        onSubmit,
        onGoToLogin,
        onCloseError,
        onUpdatePhoneCode,
        onGoBack,
        onChangeRegistrationMethod
    }
}

export default useRecoverPasswordView

const form_data = {
    mobile: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: true,
        config: {
            id: 'mobile',
            type: 'number',
            autoComplete:"new-password",
            fullWidth: true,
        },
        rules: {type: 'phone'}
    },
    mobile_country_id: {
        value:1,
        error: false,
        isVisited: true,
        isRequired: true,
        isValid: true,
        options:[...catalogs.mobile_country_codes],
        config: {
            id: 'mobile_country_id',
            type: 'select',
            autoComplete:"new-password",
            fullWidth: true,
        },
        rules: {type: 'none'}
    },
    email: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: true,
        config: {
            id: 'email',
            type: 'email',
            autoComplete:"new-password",
            fullWidth: true,
        },
        rules: {type: 'email'}
    },
    password: {
        value:null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'password',
            type: 'password',
            autoComplete:"new-password",
            placeholder:'Contraseña', 
            label:'', 
            helperText:'Contraseña no válida',
            fullWidth: true,
        },
        rules: {type: 'distance', min:1}
    },
    passwordConfirmation: {
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        config: {
            id: 'passwordConfirmation',
            type: 'password',
            fullWidth: true,
            autoComplete:"new-password",
            placeholder:'Confirmar contraseña', 
            label:'', 
            helperText:'Las contraseñas no coinciden'
        },
        rules: {type: 'distance', min:1}
    },
}